import { render, staticRenderFns } from "./RequestToPay.vue?vue&type=template&id=0cddccf8&scoped=true&"
import script from "./RequestToPay.vue?vue&type=script&lang=js&"
export * from "./RequestToPay.vue?vue&type=script&lang=js&"
import style0 from "./RequestToPay.vue?vue&type=style&index=0&id=0cddccf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cddccf8",
  null
  
)

export default component.exports